angular.module('bribac.views.addInsuranceSubscriber', [
    'bribac.components.insuranceSubscriberEditor',
    'bribac.values',
    'bribac.entities.insuranceSubscriberFactory',
    'bribac.services.api',
    "bribac.entities.kinds"
])
    .config(function ($routeProvider) {
        $routeProvider.when('/add/insurance-subscriber', {
            templateUrl: 'add-insurance-subscriber.html',
            controller: 'AddInsuranceSubscriberViewCtrl',
            controllerAs: '$ctrl',
        });
    })
    .controller('AddInsuranceSubscriberViewCtrl', function (
        $scope,
        insuranceSubscriberFactory,
        KINDS,
        api
    ) {
        const $ctrl = this;

        $ctrl.savedEntities = [];
        $ctrl.editableInsuranceSubscriber = insuranceSubscriberFactory();
        $ctrl.isSubmitting = false;

        $ctrl.successCallback = function (data) {
            const selectedOrganization = $ctrl.editableInsuranceSubscriber.organization;
            const selectedMainGroupIds = $ctrl.editableInsuranceSubscriber.mainGroupIds;

            $ctrl.savedEntities.push(data);

            $ctrl.editableInsuranceSubscriber = insuranceSubscriberFactory();
            $ctrl.editableInsuranceSubscriber.organization = selectedOrganization;
            $ctrl.editableInsuranceSubscriber.mainGroupIds = selectedMainGroupIds || [];
        };

        $ctrl.cancelEdit = function () {
            $ctrl.subscriberData = insuranceSubscriberFactory();
        };

        $ctrl.cancelInsuranceForm = function () {
            $ctrl.editableInsuranceSubscriber = insuranceSubscriberFactory();
        };

        $ctrl.saveSubscriber = function (subscriberData) {

            $ctrl.isSubmitting = true;

            api.post(KINDS.INSURANCE_SUBSCRIBER, subscriberData)
                .then(response => {
                    $ctrl.successCallback(response.data);
                })
                .catch(error => {
                    console.error('Failed to save insurance subscriber:', error);
                    alert('An error occurred while saving the subscriber.');
                })
                .finally(() => {
                    $ctrl.isSubmitting = false;
                });
        };
    });